import styled from "styled-components";
import { Court } from "./Court";
import { Tribune } from "./Tribune";
import liningLogo from "assets/images/scene/li-ning-logo.svg";


export const BadmintonScene = () => {

    return (
        <Scene>
            <Backdrop>
                <Tribune />
            </Backdrop>
            <Floor>
                <Court />
                <img src={liningLogo} alt="Li-Ning logo" />
            </Floor>
        </Scene>
    )
}

const Scene = styled.div`
    min-height: 100vh;
    width: 100%;
`;

const Backdrop = styled.div`
    height: 57vh;
    position: relative;
    background: linear-gradient(180deg, #203960 0%, #111E32 100%);
`;

const Floor = styled.div`
    height: 43vh;
    background: linear-gradient(180deg, #31315B 23.52%, #4C4C87 42.33%);
`;